export const formatIdStore = (idStore: string) => {
    let storeStr = ''
    let arrLoop = [...Array(4)]

    if (idStore[0]){
        storeStr = idStore[0].toUpperCase()
    }

    if (!parseInt(storeStr)){
        let storeNr = idStore.replace(/\D/g,'')

        arrLoop.forEach((_, i) => {
            if (storeNr[i]){
                storeStr = `${storeStr}${storeNr[i]}`
            }
        });
   
    } else {
        return ''
    }      

    return storeStr
}